import Vue from 'vue'
import CircleProgress from 'vue2-circle-progress'
Vue.component('CircleProgress', CircleProgress)
